<!--Header-->
<div class="TextCenter">
	<h4>Facility Assign Schools:</h4>
</div>

<!--Schools that are currently applied to the user-->
<div class="da-Table TopMargin">
	<p-table
		#mydt
		[value]="lstSchool"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="multiple"
		[(selection)]="SelectedSchools"
		dataKey="SchoolID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<th></th>
				<!--SchoolNumber-->
				<th>
					<p-columnFilter type="text" field="SchoolNumber" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>
				<!--School Name-->
				<th>
					<p-columnFilter type="text" field="SchoolName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<th>
					<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
				</th>
				<th pSortableColumn="SchoolNumber">School Number<p-sortIcon field="SchoolNumber"></p-sortIcon></th>
				<th pSortableColumn="SchoolName">School Name<p-sortIcon field="SchoolName"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-school>
			<tr [pSelectableRow]="school" [style.background-color]="GetBackground(school, lstSchool.indexOf(school))">
				<td>
					<p-tableCheckbox [value]="school"></p-tableCheckbox>
				</td>
				<td *ngFor="let col of cols" style="font-weight: bold">
					{{ school[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<div *ngIf="EditMode == true" class="TextCenter TopMargin">
	<label class="WarnText">NOTE: you have to go to the last page to save your changes and update the facility</label>
</div>

<!--Next-->
<div class="TextCenter TopMargin">
	<button class="btn btn-primary" (click)="onAdd()">Add</button>
	<button class="btn btn-primary" (click)="onRemove()">Remove</button>
	<button class="btn btn-primary" (click)="onNext()">Next</button>
</div>
